import React from 'react';
import { SpinnerIcon, ErrorCircleSolidIcon, CheckIcon } from '@fiverr-private/visuals';

interface Props {
    loading: boolean;
    error: boolean;
    success?: boolean;
}

export const getInputSuffixIcon = ({ loading, error, success = false }: Props) => {
    if (error) {
        return <ErrorCircleSolidIcon color="red_900" />;
    }

    if (loading) {
        return <SpinnerIcon />;
    }

    if (success) {
        return <CheckIcon color="green_900" />;
    }

    return null;
};
